import { Button, Modal } from 'antd'

type Props = {
  isOpen: boolean
  onClose: () => void
  onAddVisit: () => void
  onAddUnbillable: () => void
}
const AddTimeModal = ({ isOpen, onClose, onAddVisit, onAddUnbillable }: Props) => {
  return <Modal
    title="Add Time"
    open={isOpen}
    onCancel={onClose}
    footer={null}
  >
    <div style={{ display: 'flex', gap: 10, flexDirection: 'column' }}>
      <Button onClick={onAddVisit} type="primary" size="large">Add Visit</Button>
      <Button onClick={onAddUnbillable} type="primary" size="large">Add Unbillable Time</Button>
    </div>
  </Modal>
}

export default AddTimeModal